<template>
  <client-only>
    <component
      :is="adaptive.isDesktop ? 'ui-dropdown' : 'modal'"
      class="control-subscriptions"
      :class="{
        'control-subscriptions__dropdown': adaptive.isDesktop,
      }"
      :visible="isVisible"
      @on-close="onClose"
    >
      <div class="control-subscriptions__wrp">
        <button
          v-if="adaptive.isDesktop"
          type="button"
          class="control-subscriptions__dropdown-close"
          @click="onClose"
        >
          <f-sprite-icon :icon-link="$options.icons.IconClose" />
        </button>
        <p class="control-subscriptions__text">
          {{ infoText }}
        </p>
        <div class="control-subscriptions__buttons">
          <ui-button
            class="control-subscriptions__button"
            :text="buttonSuccessText"
            @click="onSuccess"
          />
          <ui-button
            class="control-subscriptions__button"
            :text="buttonRejectText"
            flat
            @click="onReject"
          />
        </div>
      </div>
    </component>
  </client-only>
</template>

<script>
import { mapGetters } from 'vuex';

import IconClose from '@icons/close.svg';

import { subscriptionsGtmEvents } from '@/gtm/subscriptions-gtm-events';
import { getCookieSubscriptions, setCookieSubscriptions } from '@/utils/cookies/subscriptions-cookies';

export default {
  name: 'control-subscriptions',

  inject: ['adaptive'],

  icons: {
    IconClose,
  },

  data() {
    return {
      infoText: 'Хотите быть в курсе всех акций и актуальных скидок?',
      buttonSuccessText: 'Да, хочу',
      buttonRejectText: 'Нет, спасибо',
      isActive: false,
    };
  },

  computed: {
    ...mapGetters('user', {
      IS_SUBSCRIPTIONS_NOT_ACTIVE: 'isSubscriptionsNotActive',
      LOGGED_IN: 'loggedIn',
    }),

    isVisible() {
      return this.isPreVisible && this.isActive;
    },

    isPreVisible() {
      return this.LOGGED_IN && this.IS_SUBSCRIPTIONS_NOT_ACTIVE;
    },
  },

  mounted() {
    if (this.isPreVisible && !getCookieSubscriptions()) {
      setCookieSubscriptions();
      this.isActive = true;
      subscriptionsGtmEvents.controlSubscriptionsVisible();
    }
  },

  methods: {
    async onSuccess() {
      this.isActive = false;
      subscriptionsGtmEvents.controlSubscriptionsSuccess();
      this.$router.push({ path: '/account/subscribes' });
    },
    onReject() {
      this.isActive = false;
      subscriptionsGtmEvents.controlSubscriptionsReject();
    },
    onClose() {
      this.isActive = false;
      subscriptionsGtmEvents.controlSubscriptionsCrossClick();
    },
  },
};
</script>

<style lang="scss">
$widthDropdown: 320px;

.control-subscriptions {

  &__text {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
  }

  &__buttons {
    display: flex;
    margin-top: 16px;
  }

  & &__button {
    margin-right: 16px;
    padding: 8px 18px;
  }
}

@include breakpoint("tablet") {
  .control-subscriptions {

    .modal-content {
      width: $widthDropdown;

      .modal-confirm-buttons {
        .ui-button {
          padding: 8px 18px;
        }
      }
    }
  }
}

@include breakpoint("desktop") {
  .control-subscriptions {

    &__wrp {
      position: relative;
      padding: 24px;
    }

    &#{&}__dropdown {
      width: $widthDropdown;
      left: 774px;
      top: -21px;
    }

    &__dropdown {

      &-close {
        position: absolute;
        top: 0;
        right: 0;
        padding: 14px;
        width: 48px;
        height: 48px;
        color: $gray_lu;
        cursor: pointer;
      }
    }
  }
}
</style>
